<template>
  <v-toolbar color="white" fixed dark app>
    <v-toolbar-title class="ml-0 pl-3"></v-toolbar-title>
    <v-toolbar-side-icon
      color="blue"
      @click.stop="handleDrawerToggle"
    ></v-toolbar-side-icon>
    <v-text-field
      flat
      solo-inverted
      prepend-icon="search"
      label="Search"
      class="hidden-sm-and-down"
    ></v-text-field>

    <v-btn icon @click="handleFullScreen()">
      <v-icon>fullscreen</v-icon>
    </v-btn>
    <v-tooltip bottom v-if="store_url !== undefined && store_url !== null && store_url !== ''">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="mDialog = true">
          <v-icon>shop</v-icon>
        </v-btn>
      </template>
      <span>Visit your store</span>
</v-tooltip>
    <v-menu
      offset-y
      origin="center center"
      class="elelvation-1"
      :nudge-bottom="14"
      transition="scale-transition"
    >
      <v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span slot="badge">3</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
      </v-btn>
    </v-menu>
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <v-btn icon large flat slot="activator">
        <v-avatar size="30px">
          <v-icon>person</v-icon>
        </v-avatar>
      </v-btn>
      <v-list class="pa-0">
        <v-list-tile
          color="info"
          v-for="(item, index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="black--text">{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
    
    <v-dialog
      v-model="mDialog"
      max-width="390"
    >
      <v-card class="px-3">
        <v-card-title><h5><v-icon class="pr-3 green--text">info</v-icon> Copy store your url or Go to you store</h5></v-card-title>

        <v-card-text>
            <input type="text" class="form-control" readonly :value="window_url+'/store/'+store_url">
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
           <v-btn
            flat="flat"
            @click="visitStore()"
           >
            Visit store
           </v-btn>
           <v-btn
            color="green darken-1"
            flat="flat"
            @click="mDialog = false"
           >
            Close
           </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>
<script>
import Util from "@/util";
export default {
  name: "app-toolbar",
  components: {},
  data: () => ({
    mDialog: false,
    window_url: window.location.hostname,
    items: [
      {
        icon: "account_circle",
        href: "#",
        title: "Profile",
        click: e => {
          console.log(e);
        }
      },
      {
        icon: "settings",
        href: "#",
        title: "Settings",
        click: e => {
          console.log(e);
        }
      },
      {
        icon: "fullscreen_exit",
        href: "logout",
        title: "Logout",
        click: e => {
          window.getApp.$emit("APP_LOGOUT");
        }
      }
    ],
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    store_url() {
        return window.$cookies.get('store_url') || this.$store.getters.getStore;
    }
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
    visitStore() {
        this.$router.push(`/store/${this.store_url}`)
    }
  }
};
</script>
<style scoped>
.tst1 {
  color: blue;
}
v-menu__activator {
  color: blueviolet;
}
.theme--dark.v-icon {
  color: #191c6d;
}
</style>
